import { Field, getIn, useFormikContext } from 'formik'
import { useState } from 'react'
import Visibility from 'jsx:/assets/ic_visibility.svg'
import VisibilityOff from 'jsx:/assets/ic_visibility_off.svg'
import classNames from 'classnames'
import { INPUT_STYLE, InputProps, RequiredLabel, shouldShowFormikError } from './InputField'
import { FormLabel } from '../genericComponents/layout/FormLabel'

export const Input: React.FC<
  {
    type?: string
    label?: string
    placeholder?: string
    name?: string
    className?: string
    classNameForField?: string
    disabled?: boolean
    required?: boolean
    autoFocus?: boolean
    autoComplete?: string
    maxLength?: number
    onChange?: (val: React.ChangeEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    autocompleteOff?: boolean
    list?: string
  } & InputProps
> = ({ className, classNameForField, disabled, autocompleteOff, type: originalType, ...props }) => {
  const formik = useFormikContext()
  const value = props.name ? getValueByName(props.name, formik.values) : ''
  const currentLength = String(value ?? '').length

  const [exposePassword, setExposePassword] = useState(false)
  const [type, setType] = useState(originalType)
  return (
    <div className={className}>
      {props.label && (
        <FormLabel htmlFor={props.name}>
          {props.required ? <RequiredLabel>{props.label}</RequiredLabel> : props.label}
        </FormLabel>
      )}
      <div className="flex w-full flex-nowrap">
        <Field
          {...props}
          type={type}
          className={classNames(INPUT_STYLE, classNameForField, {
            '!border-alertColor': props.name ? shouldShowFormikError(formik, props.name) : false,
          })}
          value={value || ''}
          placeholder={props.placeholder}
          {...(disabled ? { disabled: true } : {})}
          autoComplete={autocompleteOff ? 'off' : ''}
        />
        {originalType == 'password' ? (
          <div
            onClick={() => {
              setType(!exposePassword ? 'text' : originalType)
              setExposePassword(!exposePassword)
            }}
            className="flex items-center w-10 border-t-borderColor border-r-borderColor border-b-borderColor p-2 border-t border-solid border-r border-b"
          >
            {exposePassword ? <Visibility /> : <VisibilityOff />}
          </div>
        ) : (
          <></>
        )}

        <p></p>
      </div>
      {props.maxLength && (
        <div className="text-right text-xs text-secondaryFontColor mt-1">
          {currentLength}/{props.maxLength}
        </div>
      )}
      <div className="text-alertColor">
        {props.name && shouldShowFormikError(formik, props.name)
          ? getIn(formik.errors, props.name)
          : null}
      </div>
    </div>
  )
}

export const getValueByName = (name: string, values: unknown) => {
  //formik uses dot notation in field names for accessing nested values
  //break name on dots to get separate property keys
  const propertyKeys = name.split('.')
  let value = values
  propertyKeys.forEach((key) => {
    value = (value as Record<string, unknown>)[key] ?? ''
  })
  return value
}
